// The Workout Builder plan doubles as a control: tapping a step swaps the
// phone and watch mocks over to that leg of the session.

const section = document.querySelector("[data-builder]")

// Both ring gradients live here as full class names so Tailwind's source scan
// generates them; swapping backgrounds inline would skip the scan but drift
// from the utility-classes-everywhere convention.
const RING_ZONE_2 =
  "bg-[conic-gradient(from_0.5turn,#0A84FF_0turn_0.10turn,#22D3EE_0.10turn_0.27turn,rgba(255,214,10,.35)_0.27turn_0.45turn,rgba(255,159,10,.3)_0.45turn_0.62turn,rgba(255,69,58,.3)_0.62turn_0.75turn,rgba(0,0,0,0)_0.75turn_1turn)]"
const RING_ZONE_5 =
  "bg-[conic-gradient(from_0.5turn,rgba(10,132,255,.35)_0turn_0.10turn,rgba(34,211,238,.35)_0.10turn_0.27turn,rgba(255,214,10,.3)_0.27turn_0.45turn,rgba(255,159,10,.35)_0.45turn_0.62turn,#FF453A_0.62turn_0.75turn,rgba(0,0,0,0)_0.75turn_1turn)]"

const STEPS = {
  running: {
    zone: 2,
    activity: "Running",
    zoneLabel: "ZONE 2",
    bpm: "136-145",
    bpmCaption: "BPM · Base",
    watchBpm: "142",
    watchCaption: "bpm · 18:04 left",
    ring: RING_ZONE_2,
    zoneText: "text-accent",
    chipOn: ["bg-accent", "text-ink", "font-semibold"],
    tickOn: ["bg-zone-2", "shadow-[0_0_10px_#22D3EE]"],
  },
  rowing: {
    zone: 5,
    activity: "Rowing",
    zoneLabel: "ZONE 5",
    bpm: "167+",
    bpmCaption: "BPM · Peak",
    watchBpm: "171",
    watchCaption: "bpm · 6:12 left",
    ring: RING_ZONE_5,
    zoneText: "text-zone-5",
    chipOn: ["bg-zone-5", "text-white", "font-semibold"],
    tickOn: ["bg-zone-5", "shadow-[0_0_10px_#FF453A]"],
  },
}

const ZONE_TEXT = ["text-accent", "text-zone-5"]
const CHIP_ON_ALL = [...STEPS.running.chipOn, ...STEPS.rowing.chipOn]
const CHIP_OFF = ["bg-white/10", "text-white/55", "font-medium"]
const ACTIVITY_ON = ["bg-accent", "text-ink", "font-semibold"]
const ACTIVITY_OFF = ["bg-white/[0.07]", "text-white/60", "font-medium"]
const TICK_ON_ALL = [...STEPS.running.tickOn, ...STEPS.rowing.tickOn]
const TICK_DIM = { 1: "bg-zone-1/40", 2: "bg-zone-2/30", 3: "bg-zone-3/30", 4: "bg-zone-4/30", 5: "bg-zone-5/30" }

function swap(el, remove, add) {
  el.classList.remove(...remove)
  el.classList.add(...add)
}

function select(name) {
  const step = STEPS[name]

  section.querySelectorAll("[data-builder-step]").forEach((row) => {
    row.setAttribute("aria-pressed", String(row.dataset.builderStep === name))
  })

  swap(section.querySelector("[data-builder-ring]"), [RING_ZONE_2, RING_ZONE_5], [step.ring])

  const zoneLabel = section.querySelector("[data-builder-zone-label]")
  zoneLabel.textContent = step.zoneLabel
  swap(zoneLabel, ZONE_TEXT, [step.zoneText])

  section.querySelector("[data-builder-bpm]").textContent = step.bpm
  section.querySelector("[data-builder-bpm-caption]").textContent = step.bpmCaption

  section.querySelectorAll("[data-builder-chip]").forEach((chip) => {
    const on = Number(chip.dataset.builderChip) === step.zone
    swap(chip, [...CHIP_ON_ALL, ...CHIP_OFF], on ? step.chipOn : CHIP_OFF)
  })

  section.querySelectorAll("[data-builder-activity]").forEach((pill) => {
    const on = pill.dataset.builderActivity === step.activity
    swap(pill, [...ACTIVITY_ON, ...ACTIVITY_OFF], on ? ACTIVITY_ON : ACTIVITY_OFF)
  })

  const watchZone = section.querySelector("[data-builder-watch-zone]")
  watchZone.textContent = `IN ${step.zoneLabel}`
  swap(watchZone, ZONE_TEXT, [step.zoneText])

  section.querySelector("[data-builder-watch-bpm]").textContent = step.watchBpm
  section.querySelector("[data-builder-watch-caption]").textContent = step.watchCaption

  section.querySelectorAll("[data-builder-tick]").forEach((tick) => {
    const n = Number(tick.dataset.builderTick)
    swap(tick, [TICK_DIM[n], ...TICK_ON_ALL], n === step.zone ? step.tickOn : [TICK_DIM[n]])
  })
}

if (section) {
  section.querySelectorAll("[data-builder-step]").forEach((row) => {
    row.addEventListener("click", () => select(row.dataset.builderStep))
  })
}
